<template>
  <div class="image-by-map" v-show="params.flag">
    <div class="image-player" v-loading="loading">
      <div class="product-name" v-show="params.curEle === 'A01'">雷达回波</div>
      <el-tooltip class="box-item" placement="top-start" effect="light">
        <el-button
          v-show="params.curEle === 'A01'"
          type="primary"
          class="play-bn"
          style="font-size: 0.83vw"
          icon="el-icon-date"
          @click="togglePlay"
        ></el-button>
        <div slot="content">
          <div class="control">
            <div class="data-time">
              <div class="time-box">
                <div class="range">
                  <span class="label"
                    >时间范围：{{
                      this.$moment(range[0]).format("YYYY-MM-DD HH:mm")
                    }}
                    -
                    {{
                      this.$moment(range[1]).format("YYYY-MM-DD HH:mm")
                    }}</span
                  >
                  <span class="time-color"></span>
                </div>
                <div class="slider1-box">
                  <el-slider
                    v-model="range"
                    range
                    :step="step"
                    :min="minTime"
                    :max="maxTime"
                    ref="sliderRef"
                    :show-tooltip="false"
                    @input="handleInput"
                    @change="callback"
                  >
                  </el-slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tooltip>
      <div class="product-name" v-show="params.curEle === 'A04'">卫星云图</div>
      <div class="time-node">
        <div
          :class="{ node: true, active: currentIndex === index }"
          v-for="(item, index) in times"
          :key="item"
          @mouseover="handleMouseover(index)"
        >
          <i class="el-icon-loading" v-show="!loaded[index]"></i>
        </div>
      </div>
      <div class="show-time">
        {{ $moment(times[currentIndex]).format("HH:mm") }}
      </div>
      <el-button
        type="primary"
        :class="{
          'play-bn': true,
          'play-stop': timeout !== '',
          'el-icon-caret-right': timeout === '',
        }"
        @click="togglePlay"
      >
      </el-button>
      <el-button
        type="primary"
        class="play-bn el-icon-refresh-right"
        @click="init(initSTime, initETime)"
      >
      </el-button>
      <el-dropdown @command="(command) => (interval = command)">
        <el-button type="primary" class="speeds-select-bn">
          {{ interval }} s<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="0.2">0.2s</el-dropdown-item>
          <el-dropdown-item command="0.5">0.5s</el-dropdown-item>
          <el-dropdown-item command="0.8">0.8s</el-dropdown-item>
          <el-dropdown-item command="1">1s</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="legend" v-show="params.productInfo && params.curEle === 'A01'">
      <div class="name">回波强度</div>
      <div class="nbarwrap">
        <div class="nbar">
          <span class="node">5</span><span class="node">10</span
          ><span class="node">15</span><span class="node">20</span
          ><span class="node">25</span><span class="node">30</span
          ><span class="node">35</span><span class="node">40</span
          ><span class="node">45</span><span class="node">50</span
          ><span class="node">55</span><span class="node">60</span
          ><span class="node">65</span><span class="node">70</span>
        </div>
        <div class="nbar bottom">
          <span class="node" style="background-color: rgb(0, 236, 236)"></span
          ><span class="node" style="background-color: rgb(0, 160, 224)"></span
          ><span class="node" style="background-color: rgb(0, 0, 246)"></span
          ><span class="node" style="background-color: rgb(0, 254, 0)"></span
          ><span class="node" style="background-color: rgb(0, 200, 0)"></span
          ><span class="node" style="background-color: rgb(0, 144, 0)"></span
          ><span class="node" style="background-color: rgb(254, 254, 0)"></span
          ><span class="node" style="background-color: rgb(230, 192, 0)"></span
          ><span class="node" style="background-color: rgb(254, 144, 0)"></span
          ><span class="node" style="background-color: rgb(254, 0, 0)"></span
          ><span class="node" style="background-color: rgb(167, 0, 0)"></span
          ><span class="node" style="background-color: rgb(100, 0, 0)"></span
          ><span class="node" style="background-color: rgb(254, 0, 254)"></span
          ><span
            class="node"
            style="background-color: rgb(152, 84, 200)"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jsonData } from "../../api/index";
import ImageLayer from "ol/layer/Image";
import ImageStatic from "ol/source/ImageStatic";
import XYZ from "ol/source/XYZ";
import TileLayer from "ol/layer/Tile";
const baseUrl = process.env.VUE_APP_BASE_URL;
export default {
  props: ["params", "time"],
  data() {
    return {
      interval: 1,
      range: [4, 8],
      step: 1000 * 360, // 步长，单位为秒 6分钟一次
      startTime: "",
      endTime: "",
      minTime: "",
      maxTime: "",
      initSTime: "",
      initETime: "",
      MAX_DURATION: 3 * 60 * 60 * 1000, // 最大时间范围：3 小时
      // key为产品的code值
      products: {
        A01: {
          extent: [108.5, 18.2, 119, 27],
          path: "/radarpic/",
        },
        A04: {
          extent: [54.3, -5, 159.6, 66],
          path: "/cloud/3D/",
        },
      },
      currentIndex: 0,
      times: [],
      images: [],
      loaded: [],
      layer: "",
      timeout: "",
      refreshTime: "",
      loading: false,
    };
  },
  watch: {
    /**
     * 监听当前索引，切换图层
     * @param {Number} index
     */
    currentIndex(index) {
      this.setSource(index);
    },
    "params.flag": {
      handler(newVal) {
        if (newVal) {
          this.layer && this.layer.setVisible(true);
          if (this.refreshTime) {
            clearInterval(this.refreshTime);
          }
          this.refreshTime = setInterval(() => {
            this.init();
          }, 360 * 1000);
          // this.togglePlay();
        } else {
          this.layer && this.layer.setVisible(false);
        }
      },
      immediate: true,
    },
    time: {
      async handler(newVal) {
        if (newVal) {
          this.endTime = this.$moment(newVal).valueOf();
          this.startTime = this.endTime - 10440000;
          this.minTime = this.$moment(this.endTime).subtract(24, "hours");
          this.minTime = this.minTime.valueOf();
          this.maxTime = this.$moment(newVal).valueOf();
          this.range = [this.startTime, this.endTime];
          console.log(newVal);
          const stime = this.$moment(newVal)
            .subtract(1, "hour")
            .format("YYYY-MM-DD HH:mm");
          const etime = this.$moment(newVal).format("YYYY-MM-DD HH:mm");
          await this.init(stime, etime);
        }
      },
      immediate: true,
    },
  },
  created() {},

  mounted() {
    this.timmer && clearInterval(this.timmer);
    this.initETime = this.$moment(this.time).format("YYYY-MM-DD HH:mm");
    this.initSTime = this.$moment(this.time)
      .subtract(1, "hour")
      .format("YYYY-MM-DD HH:mm");
    this.timmer = setInterval(() => {
      this.init(this.initSTime, this.initETime);
    }, 5000 * 60);
  },
  methods: {
    /**
     * 初始化
     */
    async init(stime, etime) {
      this.loading = true;
      this.range = [
        this.$moment(stime).valueOf(),
        this.$moment(etime).valueOf(),
      ];
      // if (this.timeout !== '') {
      //   clearTimeout(this.timeout)
      //   this.timeout = ''
      // }
      const code = this.params.curEle;
      const data = await this.getData(stime, etime);
      if (this.params.curEle === "A01") {
        this.times = data.data.times;
        this.loaded = new Array(this.times.length).fill(true);
      } else {
        this.times = data.times.reverse();
        const images = data.images.reverse();
        // const basUrl = this.params.curEle === 'A1' ? process.env.VUE_APP_DATA : process.env.VUE_APP_BASE_API
        for (let index = images.length - 1; index >= 0; index--) {
          const image = new Image();
          image.src =
            process.env.VUE_APP_DATA + this.products[code].path + images[index];
          image.onload = () => {
            this.$set(this.loaded, index, true);
          };
          this.images[index] = image.src;
        }
      }
      this.currentIndex = this.times.length - 1;
      this.setSource(this.currentIndex);
      this.loading = false;
    },
    /**
     * 设置图片叠加到地图
     */
    setSource(index) {
      if (this.layer === "") {
        const opacity = this.params.curEle === "A01" ? 0.7 : 0.3;
        if (this.params.curEle === "A01") {
          this.layer = new TileLayer({
            zIndex: 10,
            opacity,
          });
        } else {
          this.layer = new ImageLayer({
            zIndex: 10,
            opacity,
          });
        }
        this.params.map2d.map.addLayer(this.layer);
      }
      if (this.params.curEle === "A01") {
        const time = this.times[index];
        const timeStr = this.$moment(time).format("YYYYMMDDHHmmss");
        const url = `${baseUrl}/data/radar_cut/${timeStr}/{z}/{x}/{y}.png`;
        if (!this.layer.getSource()) {
          const source = new XYZ({
            url: url,
            minZoom: 6,
            maxZoom: 11,
          });
          this.layer.setSource(source);
        } else {
          this.layer.getSource().setUrl(url);
        }
      } else {
        const source = new ImageStatic({
          url: this.images[index],
          imageExtent: this.products[this.params.curEle].extent,
        });
        this.layer.setSource(source);
      }
    },
    /**
     * 获取数据
     */
    getData(stime, etime) {
      const code = this.params.curEle;
      console.log("code", code);
      switch (code) {
        case "A01":
          try {
            const res = jsonData.getRadarImagesTimes({
              stime,
              etime,
            });

            return res;
          } catch {
            this.$message.error("当前时次无数据");
          }
          break;
        case "A04":
          return jsonData.getCloudData();
      }
    },
    /**
     * 切换播放暂停
     */
    togglePlay() {
      if (this.timeout === "") {
        this.play();
      } else {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
    },
    /**
     * 播放
     */
    play() {
      if (this.timeout !== "") {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
      this.timeout = setTimeout(() => {
        const index = this.currentIndex + 1;
        if (index === this.times.length) {
          this.currentIndex = 0;
        } else {
          this.currentIndex = index;
        }
        this.play();
      }, this.interval * 1000);
    },
    /**
     *
     */
    handleMouseover(index) {
      this.currentIndex = index;
      if (this.timeout !== "") {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
    },
    /**
     * 实时校验时间范围
     */
    handleInput(newRange) {
      let [startTime, endTime] = newRange;

      // 如果结束时间小于起始时间，交换两者角色
      if (endTime < startTime) {
        [startTime, endTime] = [endTime, startTime];
      }

      // 判断用户拖动的是哪个按钮
      const isDraggingStart = this.isDraggingStart([startTime, endTime]);

      // 如果时间范围超过最大限制，调整另一个按钮的位置
      if (endTime - startTime > this.MAX_DURATION) {
        if (isDraggingStart) {
          // 如果拖动的是起始时间，调整结束时间
          endTime = startTime + this.MAX_DURATION;
        } else {
          // 如果拖动的是结束时间，调整起始时间
          startTime = endTime - this.MAX_DURATION;
        }
      }

      // 更新滑块的值
      this.range = [startTime, endTime];

      // 更新 lastRange
      this.lastRange = [startTime, endTime];
    },

    /**
     * 判断是否正在拖动起始时间按钮
     */
    isDraggingStart(newRange) {
      if (!this.lastRange) {
        // 如果是第一次拖动，默认认为拖动的是起始时间
        return true;
      }

      const [lastStartTime, lastEndTime] = this.lastRange;
      const [newStartTime, newEndTime] = newRange;

      // 如果起始时间变化而结束时间未变，则认为拖动的是起始时间
      return newStartTime !== lastStartTime && newEndTime === lastEndTime;
    },
    /**
     * 滑动时间控件回调
     */
    async callback() {
      console.log("this.range", this.range);

      const stime = this.$moment(this.range[0]).format("YYYY-MM-DD HH:mm:00");
      const etime = this.$moment(this.range[1]).format("YYYY-MM-DD HH:mm:00");
      await this.init(stime, etime);
    },
  },
  beforeDestroy() {
    this.timmer && clearInterval(this.timmer);
  },
};
</script>
<style lang="less" scoped>
.image-by-map {
  position: absolute;
  right: 0.94vw;
  bottom: 1.9444vh;
  color: #000;
  box-sizing: border-box;
  // padding-right: 1vw;
  // background: url("../../assets/images/radar-bg.png") no-repeat;
  background-color: #fff;
  background-size: 100% 100%;

  // border-image: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5)) 1 1;
  .image-player {
    display: flex;
    align-items: center;
    padding: 0.42vw 0.83vw 0.31vw 0.73vw;

    .product-name {
      color: #000;
      width: 3.33vw;
      font-size: 0.68vw;
      // font-weight: 600;
      margin-right: 0.63vw;
    }
    /deep/ .el-slider {
      .el-slider__button {
        width: 0.83vw;
        height: 0.83vw;
      }
    }
    .time-node {
      display: flex;

      .node {
        height: 1.2rem;
        width: 0.52vw;
        background: #207dd0;
        border-radius: 0.12rem;
        margin-right: 0.2rem;
        cursor: pointer;
        opacity: 0.3;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-loading {
          color: #fff;
          font-size: 0.7rem;
        }
      }

      .node.active {
        background: #7dc5ff;
      }
    }

    .show-time {
      color: #fff;
      background: #526788;
      border-radius: 0.25rem;
      font-size: 0.8rem;
      text-align: center;
      min-width: 2rem;
      line-height: 1.5rem;
      padding: 0 0.5rem;
      margin: 0 0.5rem;
      white-space: nowrap;
    }

    .play-bn {
      padding: 0;
      height: 1.5rem;
      width: 1.5rem;
      border-radius: 0.3rem;
      margin: 0 0.5rem 0 0;
      border: none;
      background: #48adff;
      color: #fff;
      font-size: 1.25rem;
    }

    .play-stop::before {
      content: "";
      display: block;
      width: 0.7rem;
      height: 0.7rem;
      margin: 0 auto;
      background-color: #fff;
    }

    .speeds-select-bn {
      background: #48adff;
      color: #fff;
      width: 4.4rem;
      line-height: 1.5rem;
      padding: 0 0.5rem;

      i {
        font-size: 0.8rem;
      }
    }
  }

  .legend {
    display: flex;
    align-items: center;
    color: #000;
    border-top: 0.05vw solid #e7e7e7;
    padding: 0.1vw 0.68vw 0.31vw 0.78vw;

    .name {
      color: #000;
      width: 3.33vw;
      font-size: 0.68vw;
      margin-right: 0.63vw;
      // font-weight: 600;
    }

    .nbarwrap {
      .nbar {
        display: flex;
        flex-direction: row;
        justify-content: left;
        font-size: 0.8rem;

        .node {
          display: inline-block;
          // height: 1.5rem;
          line-height: 1.2rem;
          width: 1.5rem;
          text-align: center;
        }
      }

      .nbar.bottom {
        .node {
          height: 0.7rem;
        }
      }
    }
  }
}
</style>
